import React from 'react';
import s from './BrandDetailsMobileFooter.module.css';

const BrandDetailsMobileFooter = ({ backgroundImageUrl }) => {
  return (
    <div className={s.container}>
      <img
        className={s.backgroundImage}
        src={backgroundImageUrl}
      />
      <div className={`paddedMaxWidthContainer ${s.mainText}`}>
        DAYMADE is an associated brand of, and operated by, DAYMADE LTD
        (registered in England & Wales, company number 12333770).
      </div>
    </div>
  );
};

export default BrandDetailsMobileFooter;
